import invariant from 'tiny-invariant'

const ruleRowDroppableIdPrefix = 'rule-row-'

export const getRuleRowIndexFromDroppableId = droppableId => {
  invariant(
    droppableId.startsWith(ruleRowDroppableIdPrefix),
    'incorrectly formatted ruleRow droppable ID encountered')

  return droppableId.replace(ruleRowDroppableIdPrefix, '')
}

export const getRuleRowDroppableId = ruleRowIndex => {
  return ruleRowDroppableIdPrefix + ruleRowIndex.toString()
}
